module.exports = __webpack_public_path__ + "static/PersonSweepingFloor-45ef58f720c83b61203e8428a2ae93f4.jpg";